import React from 'react';

const LoadingState = () => {
  return (
    <section id="services" className="services-section py-5" style={{ backgroundColor: `var(--color-bodyBlack)`}}>
      <div className="container">
        <div className="row mb-5">
          <div className="col-12 text-center">
            <h2 className="display-4 fw-bold mb-4 service-title" style={{ color: `var(--color-white)` }}>
              Our Core Services
            </h2>
            <p className="lead subtitle" style={{ color: `var(--color-white)`, maxWidth: '800px', margin: '0 auto' }}>
              Empowering your business with cutting-edge technology solutions and expert guidance
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <div className="loading-spinner"></div>
            <p style={{ color: `var(--color-white)`, marginTop: '20px' }}>
              Loading services...
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoadingState;